import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCLogger } from "../../../../js/lib/logger";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { TrackingEvent } from "../../ga/TrackingEvent";
import { ApplicationData } from "../ApplicationData";
import { GoogleAnalyticsManager } from "./GoogleAnalyticsManager";

export const TLCAnalyticsManager = (function(){

	class Manager extends GoogleAnalyticsManager {
		constructor(options) {
			options = options || {};
			options.enabled = true;
			options.dimensionMap = {
				'dimension1': 'AdminOrUser',
				'dimension2': 'CustomerId',
				'dimension3': 'LibraryType',
				'dimension4': 'Revision'
			};
			options.variables = {
				'CustomerId': ApplicationData.globalConfiguration.contentServerSettings.contentServerCustomerId,
				'LibraryType': window.libraryType,
				'Revision': window.svnRevision
			};

			super(options);
		}
		setupPersonalListeners() {
			//implement in sub class, throw exception
			TLCLogger.log("setting up personal listeners from SUB class for " + this.googleAnalyticTracker.trackingCode);
			var _this = this;

			TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onClickLandingPageJacket, function (event) {
				_this.googleAnalyticTracker.trackEvent(new TrackingEvent('LandingPage', 'JacketClick'));
			});
			TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onClickLandingPageNavItem, function (event) {
				_this.googleAnalyticTracker.trackEvent(new TrackingEvent('LandingPage', 'ChangeListClick'));
			});
			TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onClickLandingPageNext, function (event) {
				_this.googleAnalyticTracker.trackEvent(new TrackingEvent('LandingPage', 'PagingClick', 'next'));
			});
			TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onClickLandingPagePrev, function (event) {
				_this.googleAnalyticTracker.trackEvent(new TrackingEvent('LandingPage', 'PagingClick', 'prev'));
			});

			TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onClickAvailabilityLink, function (event) {
				if (event.resource.downloadable === true) {
					_this.trackEResourceClick('availability', event.resource.shortTitle, event.resource);
				}
			});

			TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onClickMoreOptionsLink, function (event) {
				_this.trackEResourceClick('moreoptions', event.resource.shortTitle, event.resource);
			});

			TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onClickDownloadLink, function (event) {
				_this.trackEResourceClick('download', event.resource.shortTitle, event.resource);
			});

			TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onAddFacetFilterToResults, function (event) {
				_this.googleAnalyticTracker.trackEvent(new TrackingEvent("SearchFilters", event.facetFilter.facetDisplay, "Add")); //TODO confirm event.changeType = add vs. remove
			});
			TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onRemoveFacetFilter, function (event) {
				_this.googleAnalyticTracker.trackEvent(new TrackingEvent("SearchFilters", "Remove")); //TODO set the removed value
			});

			$('body').on('click', '.helpLink', function (event) {
				_this.googleAnalyticTracker.trackEvent(new TrackingEvent("Help", "show", event.target));
			});

			TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onReviewTitleResponse, function (event) {
				_this.googleAnalyticTracker.trackEvent(new TrackingEvent("Review", "add"));
			});

			TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onRemoveReviewResponse, function (event) {
				_this.googleAnalyticTracker.trackEvent(new TrackingEvent("Review", "remove"));
			});
		}
	}


	//public functions
	var instance, publicFunctions = {
		getTrackingCode: function(){
			return instance.googleAnalyticTracker.trackingCode;
		},
		getEnabled: function(){
			return instance.googleAnalyticTracker.enabled;
		},
		getGoogleAnalyticsTracker: function(){
			return this.googleAnalyticTracker;
		}
	};

	var _static = {
		getInstance: function(options){
			if (instance === undefined) {
				instance = new Manager(options);
			}
			return publicFunctions;
		}
	};
	return _static;
})();